var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloudUpload28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 7.5a5.476 5.476 0 0 0-3.801 1.525 1.5 1.5 0 0 1-1.627.295A4 4 0 0 0 6 12.976a1.5 1.5 0 0 1-.832 1.335 3 3 0 0 0-.404 5.136c.618.44 1.197 1.056 1.197 1.814 0 .922-.806 1.66-1.663 1.322a6.002 6.002 0 0 1-1.92-9.943c.407-.385.708-.877.85-1.42a7.003 7.003 0 0 1 7.643-5.166 2.82 2.82 0 0 0 1.788-.363 8.503 8.503 0 0 1 12.611 5.338c.105.443.325.851.624 1.194a6.5 6.5 0 0 1-2.06 10.128c-.891.433-1.795-.332-1.795-1.322 0-.705.486-1.3 1.051-1.722A3.495 3.495 0 0 0 24.5 16.5c0-1.15-.553-2.17-1.414-2.81a1.5 1.5 0 0 1-.6-1.096A5.5 5.5 0 0 0 17 7.5Z",
    fill: "currentColor",
    fillOpacity: 0.92
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.823 14.56a1.25 1.25 0 0 0-1.646 0l-4 3.5a1.25 1.25 0 1 0 1.646 1.88l1.927-1.685V25a1.25 1.25 0 0 0 2.5 0v-6.745l1.927 1.686a1.25 1.25 0 0 0 1.646-1.882l-4-3.5Z",
    fill: "currentColor",
    fillOpacity: 0.92
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload28);
export default __webpack_public_path__ + "static/media/cloud_upload_28.a86a39dd.svg";
export { ForwardRef as ReactComponent };